var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMetro = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 8,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#98918A",
  d: "M11 .95a.7.7 0 0 0-.6.39L8.47 4.87l1.01 1.85c.1.16.25.27.42.3l.15.03a.7.7 0 0 0 .6-.39l2.92-5.34a.7.7 0 0 1 .45-.35 1 1 0 0 1 .15-.01H11ZM7.04 7.03a.7.7 0 0 0 .42-.3l1-1.86-1.92-3.53a.7.7 0 0 0-.58-.39c-.05 0-.09 0-.13.02a.72.72 0 0 0-.42.3l-1.03 1.9 1.9 3.5a.7.7 0 0 0 .6.38z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#98918A",
  d: "M16.86 5.13 14.8 1.34a.7.7 0 0 0-.6-.38h-.02l-.15.01a.74.74 0 0 0-.45.34l-.98 1.8 1.76 3.22c.35.65 1.2.9 1.89.56a1.3 1.3 0 0 0 .62-1.76ZM5.63.95H2.82a.7.7 0 0 0-.6.39L.13 5.14A1.3 1.3 0 0 0 .76 6.9c.68.34 1.53.08 1.89-.57l1.6-2.91L5.4 1.28c.1-.16.25-.27.42-.31l.15-.02h-.35Zm4.42 6.1c-.05 0-.1 0-.15-.02a.7.7 0 0 1-.42-.3l-1-1.86-1.02 1.85a.7.7 0 0 1-.42.3.6.6 0 0 1-.15.03z"
})));
export default SvgMetro;